export const getValidDevFeedCursor = cursor => {
  if (!cursor || typeof cursor !== 'object') return null;
  const { timestamp, id, idType } = cursor;

  if (!timestamp || !id) return null;
  return {
    timestamp,
    id,
    ...(idType === 'string' || idType === 'objectId' ? { idType } : {})
  };
};
